import {PolLogo, PolTextLogo} from "../logo";

export default function Splash() {
    return (
        <div className="w-screen h-screen flex-center bg-pol-light-purple">
            <div>
                <div className="pulsate-bck flex items-center gap-x-1.5">
                    <PolLogo />
                    <PolTextLogo />
                </div>
            </div>
        </div>
    )
}
